import { Provider } from '@angular/core'

import { DialogService } from 'primeng/dynamicdialog'

import { DIALOG_FACADE } from '@ti/core/contracts/dialog'
import { SIDEBAR_BADGES_MODEL } from '@ti/core/contracts/sidebar'

import { AdaptiveDialogService } from '../layout/services/adaptive-dialog.service'
import { DialogFacade } from '../layout/services/dialog-facade'
import { SidebarBadgesModel } from '../layout/services/sidebar-badges.model'

export const DIALOG_SERVICE_PROVIDER: Provider = [
  AdaptiveDialogService,
  { provide: DialogService, useExisting: AdaptiveDialogService },
]

export const provideCustomDialogService = () => {
  return [DIALOG_SERVICE_PROVIDER]
}

export const provideDialogFacade = () => {
  return [{ provide: DIALOG_FACADE, useClass: DialogFacade }]
}

export const provideSidebarBadges = () => {
  return [{ provide: SIDEBAR_BADGES_MODEL, useClass: SidebarBadgesModel }]
}

export const provideUiKitGlobals = (): Provider[] => {
  return [...provideDialogFacade(), ...provideSidebarBadges()]
}
